import React from 'react';
import { useRecoilValue } from 'recoil';
import { proxySetIdState } from 'venn-state';

interface WithAnalysisViewIdProps {
  children: (analysisViewId: string | undefined) => React.ReactNode;
}

export const WithAnalysisViewId = ({ children }: WithAnalysisViewIdProps) => {
  const proxySetId = useRecoilValue(proxySetIdState);
  return <>{children(proxySetId)}</>;
};
